import React from 'react';

interface ShareButtonProps {
  onClick: () => void;
  highlighted?: boolean;
  isEditing?: boolean;
  showLabel?: boolean;
}

export default function ShareButton({ onClick, highlighted, isEditing, showLabel }: ShareButtonProps) {
  return (
    <button className={`shop-header__btn${!showLabel && !isEditing ? ' shop-header__btn--icon-only' : ''}${isEditing ? ' shop-header__btn--edit' : ''}${highlighted ? ' shop-header__btn--highlighted' : ''} shop-header__btn--share`} onClick={onClick}>
      {isEditing ? (
        <>Edit <img className='shop-header__share-icon' src='/static/image/icon__at.svg' alt='Edit handle' /></>
      ) : (
        <>
          {showLabel && 'Share'}
          <svg
            className='shop-header__share-icon'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <title>Share</title>
            <path
              d='M6.39402 8.20217L9.5539 5.0423M12.7863 3.11388L10.119 11.7825C9.88001 12.5593 9.7604 12.9479 9.55424 13.0767C9.37541 13.1885 9.15401 13.2072 8.95925 13.1263C8.73468 13.0332 8.55241 12.6693 8.1888 11.942L6.4994 8.56324C6.4417 8.44784 6.41282 8.39038 6.37428 8.34037C6.34008 8.296 6.30061 8.25603 6.25624 8.22183C6.20737 8.18416 6.15087 8.15591 6.04062 8.10079L2.65404 6.4075C1.92681 6.04389 1.56317 5.86192 1.46999 5.63735C1.38918 5.44259 1.40761 5.22098 1.51934 5.04216C1.64817 4.83596 2.03676 4.71617 2.81386 4.47706L11.4824 1.80981C12.0934 1.62183 12.399 1.52792 12.6053 1.60367C12.7851 1.66966 12.9268 1.81122 12.9927 1.99097C13.0685 2.19722 12.9745 2.50266 12.7867 3.11298L12.7863 3.11388Z'
              stroke='black'
              strokeWidth='1.25'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </>
      )}
    </button>
  );
}
